import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CommonFunctionsService, DialogType } from './common-functions.service';
import { NotificationType, SilentActions, } from './definitions.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/fire/messaging";
import * as i2 from "./common-functions.service";
import * as i3 from "./log.service";
import * as i4 from "./auth.service";
import * as i5 from "@angular/router";
var MessagingService = /** @class */ (function () {
    function MessagingService(angularFireMessaging, commonFunctions, log, authenticationService, router) {
        this.angularFireMessaging = angularFireMessaging;
        this.commonFunctions = commonFunctions;
        this.log = log;
        this.authenticationService = authenticationService;
        this.router = router;
        this.currentMessage = new BehaviorSubject(null);
    }
    //Starts asking if user wants to receive push notification
    MessagingService.prototype.requestPermission = function (force) {
        if (force === void 0) { force = false; }
        if (this.authenticationService.isLoggedIn) {
            this.requestNotificationPermission(this.authenticationService.userDetails.uid, force);
        }
        else {
            this.commonFunctions.showErrorToast('User nicht eingeloggt');
        }
    };
    MessagingService.prototype.receiveMessage = function () {
        var _this = this;
        this.angularFireMessaging.messages.subscribe(function (payload) {
            console.log('Message received. ', payload);
            _this.currentMessage.next(payload);
            _this.displayNotification(payload);
        });
    };
    //Shows a push notification
    MessagingService.prototype.displayNotification = function (notification) {
        if (!notification) {
            return;
        }
        var data = notification.notification;
        //silent action
        if (data.messageType == NotificationType.SilentAction) {
            this.handleSilentActions();
            return;
        }
        //Standard
        if (data.messageType == NotificationType.Standard) {
            this.commonFunctions.openDialog(data.messageTitle, data.messageBody);
        }
        //message from admin
        else if (data.messageType == NotificationType.MessageFromAdmin) {
            this.commonFunctions.openDialog('Nachricht vom Admin', data.messageBody);
        }
        //general reminder
        else if (data.messageType == NotificationType.GeneralReminder) {
            this.commonFunctions.openDialog('Erinnerung', data.messageBody);
        }
        //route used?
        if (data.route) {
            this.router.navigate(['/' + data.route]);
        }
    };
    //Handles silent actions without any user noitification
    MessagingService.prototype.handleSilentActions = function () {
        //handle silent actions
        if (this.currentMessage.value.notification.silentActionId ==
            SilentActions.SendLogFilesToDev) {
            this.log
                .sendLogsToDev(this.authenticationService.userId)
                .then(function (fulfilled) {
                console.log('Logs erfolgreich versandt');
            }, function (rejectMsg) {
                console.log('Logs nicht versandt: ' + rejectMsg);
            });
        }
        if (this.currentMessage.value.notification.silentActionId ==
            SilentActions.LogOut) {
            this.authenticationService.logout();
        }
        if (this.currentMessage.value.notification.silentActionId ==
            SilentActions.ClearLogFiles) {
            this.log.clearLogs();
        }
    };
    /**
     * Requests permission to retrieve web notifications
     * Source: https://github.com/angular/angularfire/blob/master/docs/messaging/messaging.md
     */
    MessagingService.prototype.requestNotificationPermission = function (userId, force) {
        var _this = this;
        if (force === void 0) { force = false; }
        //already requested?
        var alreadyRequested = localStorage.getItem('notiTokenRequested');
        if (alreadyRequested == null || force) {
            this.commonFunctions
                .openDialog('Benachrichtigungen', 'Möchtest du Push-Benachrichtigungen erhalten?', DialogType.INFO, 'Nein', 'Ja')
                .afterClosed()
                .subscribe(function (result) {
                localStorage.setItem('notiTokenRequested', 'true');
                if (result.result == 1) {
                    _this.angularFireMessaging.requestToken.subscribe(function (token) {
                        _this.log.debug('Permission for receiving notifications granted. Sending token to server', token, CommonFunctionsService.name);
                        _this.commonFunctions.saveNotiTokenInUserCollection(userId, token);
                    }, function (error) {
                        _this.commonFunctions.showErrorToast('Registrierung nicht möglich');
                        _this.log.error('Request for receiving notification token failed', error, CommonFunctionsService.name);
                    });
                }
            });
        }
    };
    MessagingService.ɵfac = function MessagingService_Factory(t) { return new (t || MessagingService)(i0.ɵɵinject(i1.AngularFireMessaging), i0.ɵɵinject(i2.CommonFunctionsService), i0.ɵɵinject(i3.LogService), i0.ɵɵinject(i4.AuthService), i0.ɵɵinject(i5.Router)); };
    MessagingService.ɵprov = i0.ɵɵdefineInjectable({ token: MessagingService, factory: MessagingService.ɵfac, providedIn: 'root' });
    return MessagingService;
}());
export { MessagingService };
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MessagingService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: i1.AngularFireMessaging }, { type: i2.CommonFunctionsService }, { type: i3.LogService }, { type: i4.AuthService }, { type: i5.Router }]; }, null); })();
//# sourceMappingURL=messaging.service.js.map